import { render, staticRenderFns } from "./EmailsNav.vue?vue&type=template&id=43f66974&"
import script from "./EmailsNav.vue?vue&type=script&lang=js&"
export * from "./EmailsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports